import React from "react";
import { lazy, Suspense } from "react";
import { SectionSnap } from "./custom/SectionSnap";

const Nav = lazy(() => import("./Nav"));
const Section1 = lazy(() => import("./Sections/Section1"));
const Section2 = lazy(() => import("./Sections/Section2"));
const Detailer = lazy(() => import("./Detailer"));
const DetailerMain = lazy(() => import("./DetailerMain"));
const Section9 = lazy(() => import("./Sections/Section9"));
const Section10 = lazy(() => import("./Sections/Section10"));
const Section11 = lazy(() => import("./Sections/Section11"));
const ConnectNow = lazy(() => import("./ConnectNow"));

export const Landing = ({ setShow_page, show_page, setModal, Modal }) => {
  return (
    <Suspense fallback={<div></div>}>
      <div className="App" id="app">
        <Nav active={true} />
        <SectionSnap>
          <Section1 {...{ setShow_page }} />
        </SectionSnap>
        {true ? (
          <>
            <SectionSnap>
              <Section2 />
            </SectionSnap>
            <SectionSnap>
              <div className="section3_main">
                <div className="section3_main_inner1">
                  <Detailer
                    show_page={show_page}
                    img="https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/vTS3hsw.png"
                    type={1}
                    reverse={false}
                    shade={true}
                  />
                </div>
                <DetailerMain
                  cust_class="section4"
                  title={
                    <>
                      Don't Vent. <span className="f-green">Ventilate.</span>
                    </>
                  }
                  subtxt={
                    <>
                      Enjoy the freshest of environments, every time you enter
                      your bathroom. With our air flushing system, you are
                      guaranteed to have the cleanest air in circulation! Flush
                      out foul odour, hot steam, humidity and turn your bathroom
                      into the place it’s meant to be - Your personal relaxation
                      pod
                    </>
                  }
                  // btntxt={<>Let there be peace!</>}
                  btntxt={<>Enlighten me</>}
                  arrowside={{ justifyContent: "flex-end" }}
                  img={
                    "https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/VAgyAM8.png"
                  }
                  img2={
                    "https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/Silvento-ec_V-EC%20(1)%201.png"
                  }
                  floater_img={""}
                />
              </div>
            </SectionSnap>
            <SectionSnap>
              <div className="section4_main">
                <div className="section4_main_inner1">
                  <Detailer
                    show_page={show_page}
                    img="https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/XW8ZzPt.png"
                    type={2}
                    reverse={true}
                    shade={false}
                  />
                </div>
                <DetailerMain
                  reverse={true}
                  cust_class="section6"
                  floatimgAnimation={true}
                  title={
                    <>
                      Is the
                      <span className="f-green"> Noise killing </span>
                      your Joys?
                    </>
                  }
                  subtxt={
                    <>
                      Savor your bathroom time in silence, peace, and
                      tranquility! We give you our out of the world noiseless
                      fan system, so that your brain can make all the noise.
                    </>
                  }
                  btntxt={<>Let there be peace!</>}
                  img={
                    "https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/eyH82Dr.png"
                  }
                  img2={
                    "https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/Silvento-ec_V-EC%20(1)%201.png"
                  }
                  arrowside={{ justifyContent: "flex-end" }}
                  floater_img={
                    "https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/yWeGOkr.png"
                  }
                />
              </div>
            </SectionSnap>
            <SectionSnap>
              <div className="section5_main">
                <div className="section5_main_inner1">
                  <Detailer
                    show_page={show_page}
                    img="https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/KTbawrB.png"
                    type={3}
                    reverse={false}
                    shade={false}
                  />
                </div>
                <DetailerMain
                  reverse={false}
                  cust_class="section8"
                  floatimgAnimation={true}
                  title={
                    <>
                      <span className="f-green">Harmful Sprays </span>
                      Away! Hurray!
                    </>
                  }
                  subtxt={
                    <>
                      Enjoy the freshest of environments, every time you enter
                      your bathroom with our revolutionary Air Flushing Systems.
                      We ensure the cleanest possible air by flushing out foul
                      odour, hot steam, humidity, etc. and turn your bathroom
                      into the place it’s meant to be - Your personal relaxation
                      pod.
                    </>
                  }
                  // title={
                  //   <>
                  //     <span className="f-green">The stink </span>
                  //     won't let you think.
                  //   </>
                  // }
                  // subtxt={
                  //   <>
                  //     Foul smell leaves a bad taste in your mouth. Hence we
                  //     capture the foul odor at the source, flushing it out
                  //     before it reaches your nose. Additionally, we also spare
                  //     a thought for the person using the bathroom after you
                  //     {" ;)"}.
                  //   </>
                  // }
                  // btntxt={<>Go green! Keep my bathroom clean</>}
                  btntxt={<>Keep my bathroom clean</>}
                  img={
                    "https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/WrVDLIZ.png"
                  }
                  img2={
                    " https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/Silvento-ec_V-EC%20(1)%201.png"
                  }
                  arrowside={{ justifyContent: "flex-start" }}
                  floater_img={
                    "https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/HVBSO4n.png"
                  }
                />
              </div>
            </SectionSnap>
            <SectionSnap>
              <Section9 />
            </SectionSnap>
            <SectionSnap>
              <Section10 />
            </SectionSnap>
            <SectionSnap>
              <Section11 />
            </SectionSnap>
            {/* <SectionSnap> */}
            <ConnectNow
              setModal={setModal}
              reverse={false}
              cust_class="section9"
              title={{
                img: "https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/EnI4jNK.png",
                desc: "to harness the power of Air Flushing Systems in Bathrooms & Other Living Spaces?",
              }}
            />
            {/* </SectionSnap> */}

            <div className={"modal " + (Modal ? "active_modal" : "")}>
              <svg
                width="620"
                height="376"
                viewBox="0 0 620 376"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_1_5300)">
                  <g clip-path="url(#clip0_1_5300)">
                    <rect
                      x="5"
                      y="3"
                      width="606"
                      height="362"
                      rx="8"
                      fill="#131315"
                    />
                    <g opacity="0.34" filter="url(#filter1_df_1_5300)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M358.861 243.342C361.955 271.569 356.702 303.01 335.941 318.967C313.357 336.326 284.254 335.282 267.259 313.751C252.121 294.574 261.413 263.72 271.749 237.645C282.645 210.159 296.822 177.59 320.617 179.146C345.338 180.762 355.578 213.389 358.861 243.342Z"
                        fill="url(#paint0_linear_1_5300)"
                      />
                    </g>
                    <path
                      d="M579.286 49.2857L565 35M579.286 35L565 49.2857"
                      stroke="#F0F0F0"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setModal(false);
                      }}
                    />
                    <path
                      d="M246.716 162V139.568H242.588V136.08H255.516V139.568H251.452V162H246.716ZM257.65 162V136.08H262.002V145.264C262.642 144.624 263.335 144.123 264.082 143.76C264.85 143.397 265.682 143.216 266.578 143.216C267.325 143.216 267.922 143.408 268.37 143.792C268.818 144.155 269.149 144.645 269.362 145.264C269.575 145.883 269.682 146.555 269.682 147.28V162H265.33V148.144C265.33 147.589 265.245 147.163 265.074 146.864C264.903 146.565 264.573 146.416 264.082 146.416C263.783 146.416 263.442 146.501 263.058 146.672C262.695 146.843 262.343 147.067 262.002 147.344V162H257.65ZM276.451 162.288C275.619 162.288 274.904 162.075 274.307 161.648C273.71 161.2 273.251 160.645 272.931 159.984C272.611 159.301 272.451 158.597 272.451 157.872C272.451 156.72 272.664 155.749 273.091 154.96C273.518 154.171 274.083 153.509 274.787 152.976C275.491 152.443 276.291 151.984 277.187 151.6C278.083 151.195 278.99 150.832 279.907 150.512V148.912C279.907 148.379 279.864 147.931 279.779 147.568C279.715 147.205 279.576 146.928 279.363 146.736C279.171 146.544 278.862 146.448 278.435 146.448C278.072 146.448 277.774 146.533 277.539 146.704C277.326 146.875 277.166 147.12 277.059 147.44C276.974 147.739 276.92 148.091 276.899 148.496L276.835 149.616L272.707 149.456C272.771 147.323 273.294 145.755 274.275 144.752C275.278 143.728 276.792 143.216 278.819 143.216C280.675 143.216 282.019 143.728 282.851 144.752C283.704 145.776 284.131 147.163 284.131 148.912V157.456C284.131 158.139 284.142 158.757 284.163 159.312C284.206 159.867 284.248 160.368 284.291 160.816C284.355 161.264 284.408 161.659 284.451 162H280.547C280.483 161.573 280.398 161.093 280.291 160.56C280.206 160.005 280.142 159.6 280.099 159.344C279.886 160.091 279.48 160.773 278.883 161.392C278.286 161.989 277.475 162.288 276.451 162.288ZM278.051 159.056C278.328 159.056 278.584 158.992 278.819 158.864C279.075 158.715 279.299 158.544 279.491 158.352C279.683 158.16 279.822 157.989 279.907 157.84V152.688C279.438 152.965 278.99 153.243 278.563 153.52C278.158 153.797 277.795 154.107 277.475 154.448C277.176 154.768 276.942 155.12 276.771 155.504C276.622 155.888 276.547 156.336 276.547 156.848C276.547 157.531 276.675 158.075 276.931 158.48C277.208 158.864 277.582 159.056 278.051 159.056ZM287.336 162V143.504H291.688V145.36C292.349 144.72 293.043 144.208 293.768 143.824C294.515 143.419 295.315 143.216 296.168 143.216C296.936 143.216 297.544 143.408 297.992 143.792C298.44 144.155 298.771 144.645 298.984 145.264C299.197 145.883 299.304 146.555 299.304 147.28V162H294.952V148.144C294.952 147.589 294.867 147.163 294.696 146.864C294.525 146.565 294.195 146.416 293.704 146.416C293.405 146.416 293.075 146.501 292.712 146.672C292.371 146.843 292.029 147.056 291.688 147.312V162H287.336ZM302.524 162V136.08H306.876V150.96L311.644 143.504H316.38L311.74 150.928L316.284 162H311.708L308.348 152.88L306.876 154.928V162H302.524ZM325.995 167.024V163.888C326.742 163.888 327.35 163.845 327.819 163.76C328.288 163.675 328.63 163.525 328.843 163.312C329.056 163.099 329.163 162.8 329.163 162.416C329.163 162.139 329.088 161.701 328.939 161.104C328.811 160.507 328.662 159.856 328.491 159.152L324.427 143.504H328.651L331.051 155.696L333.131 143.504H337.323L333.003 162.736C332.768 163.824 332.374 164.677 331.819 165.296C331.264 165.915 330.571 166.352 329.739 166.608C328.907 166.885 327.936 167.024 326.827 167.024H325.995ZM344.936 162.288C343.592 162.288 342.483 162.043 341.608 161.552C340.733 161.04 340.072 160.304 339.624 159.344C339.197 158.384 338.984 157.221 338.984 155.856V149.648C338.984 148.283 339.197 147.12 339.624 146.16C340.072 145.2 340.733 144.475 341.608 143.984C342.483 143.472 343.592 143.216 344.936 143.216C346.28 143.216 347.389 143.472 348.264 143.984C349.16 144.475 349.821 145.2 350.248 146.16C350.696 147.12 350.92 148.283 350.92 149.648V155.856C350.92 157.221 350.696 158.384 350.248 159.344C349.821 160.304 349.16 161.04 348.264 161.552C347.389 162.043 346.28 162.288 344.936 162.288ZM344.968 159.28C345.459 159.28 345.821 159.141 346.056 158.864C346.291 158.587 346.44 158.213 346.504 157.744C346.568 157.253 346.6 156.72 346.6 156.144V149.36C346.6 148.784 346.568 148.261 346.504 147.792C346.44 147.323 346.291 146.949 346.056 146.672C345.821 146.373 345.459 146.224 344.968 146.224C344.477 146.224 344.115 146.373 343.88 146.672C343.645 146.949 343.485 147.323 343.4 147.792C343.336 148.261 343.304 148.784 343.304 149.36V156.144C343.304 156.72 343.336 157.253 343.4 157.744C343.485 158.213 343.645 158.587 343.88 158.864C344.115 159.141 344.477 159.28 344.968 159.28ZM356.874 162.288C356.149 162.288 355.552 162.107 355.082 161.744C354.613 161.36 354.272 160.859 354.058 160.24C353.845 159.6 353.738 158.928 353.738 158.224V143.504H358.09V157.424C358.09 157.979 358.176 158.416 358.346 158.736C358.538 159.035 358.88 159.184 359.37 159.184C359.69 159.184 360.01 159.099 360.33 158.928C360.672 158.757 361.002 158.555 361.322 158.32V143.504H365.674V162H361.322V160.24C360.704 160.837 360.021 161.328 359.274 161.712C358.528 162.096 357.728 162.288 356.874 162.288ZM370.239 155.92L368.927 136.112H373.279L371.743 155.92H370.239ZM368.895 162V157.776H373.119V162H368.895Z"
                      fill="#6E9C25"
                    />
                    <path
                      d="M198.939 198L194.715 172.08H197.723L200.507 190.704L203.995 172.176H206.555L210.075 190.8L212.795 172.08H215.739L211.579 198H208.955L205.339 178.8L201.691 198H198.939ZM223.411 198.256C221.96 198.256 220.84 197.979 220.051 197.424C219.261 196.848 218.707 196.016 218.387 194.928C218.088 193.819 217.939 192.464 217.939 190.864V186.64C217.939 184.997 218.099 183.632 218.419 182.544C218.739 181.456 219.293 180.635 220.083 180.08C220.893 179.525 222.003 179.248 223.411 179.248C224.968 179.248 226.109 179.568 226.835 180.208C227.581 180.848 228.072 181.776 228.307 182.992C228.541 184.187 228.659 185.627 228.659 187.312V188.816H221.363V192.528C221.363 193.275 221.427 193.883 221.555 194.352C221.704 194.821 221.928 195.173 222.227 195.408C222.547 195.621 222.952 195.728 223.443 195.728C223.955 195.728 224.339 195.611 224.595 195.376C224.872 195.12 225.053 194.768 225.139 194.32C225.245 193.851 225.299 193.307 225.299 192.688V191.568H228.627V192.272C228.627 194.128 228.232 195.589 227.443 196.656C226.653 197.723 225.309 198.256 223.411 198.256ZM221.363 186.96H225.299V185.296C225.299 184.528 225.256 183.888 225.171 183.376C225.085 182.843 224.904 182.448 224.627 182.192C224.371 181.915 223.955 181.776 223.379 181.776C222.824 181.776 222.397 181.904 222.099 182.16C221.821 182.416 221.629 182.853 221.523 183.472C221.416 184.069 221.363 184.901 221.363 185.968V186.96ZM241.216 198L238.24 179.504H241.056L242.976 193.136L245.44 179.504H248.064L250.528 193.072L252.448 179.504H255.264L252.192 198H249.312L246.784 184.944L244.288 198H241.216ZM258.108 198V179.504H261.532V198H258.108ZM258.108 176.752V173.168H261.532V176.752H258.108ZM265.517 198V172.08H268.941V198H265.517ZM272.829 198V172.08H276.253V198H272.829ZM291.934 203.728C290.825 203.728 289.822 203.611 288.926 203.376C288.03 203.141 287.326 202.768 286.814 202.256C286.302 201.744 286.046 201.072 286.046 200.24C286.046 199.643 286.174 199.12 286.43 198.672C286.686 198.224 287.017 197.84 287.422 197.52C287.828 197.179 288.254 196.901 288.702 196.688C288.105 196.517 287.657 196.251 287.358 195.888C287.06 195.504 286.91 195.109 286.91 194.704C286.91 194.021 287.092 193.435 287.454 192.944C287.817 192.453 288.318 191.92 288.958 191.344C288.254 190.811 287.721 190.128 287.358 189.296C286.996 188.464 286.814 187.312 286.814 185.84C286.814 184.389 287.006 183.184 287.39 182.224C287.796 181.243 288.382 180.507 289.15 180.016C289.94 179.504 290.9 179.248 292.03 179.248C293.033 179.248 293.833 179.419 294.43 179.76C295.049 180.101 295.518 180.613 295.838 181.296C295.945 181.125 296.233 180.837 296.702 180.432C297.172 180.005 297.716 179.653 298.334 179.376L298.846 179.152L299.71 181.36C299.433 181.403 299.06 181.509 298.59 181.68C298.142 181.829 297.716 181.989 297.31 182.16C296.926 182.309 296.681 182.437 296.574 182.544C296.724 182.907 296.852 183.429 296.958 184.112C297.086 184.795 297.15 185.403 297.15 185.936C297.15 187.195 296.99 188.304 296.67 189.264C296.35 190.224 295.817 190.981 295.07 191.536C294.345 192.069 293.332 192.336 292.03 192.336C291.753 192.336 291.454 192.315 291.134 192.272C290.814 192.229 290.526 192.176 290.27 192.112C290.142 192.304 290.004 192.528 289.854 192.784C289.726 193.04 289.662 193.285 289.662 193.52C289.662 193.755 289.78 193.947 290.014 194.096C290.27 194.224 290.665 194.309 291.198 194.352L294.078 194.608C295.529 194.736 296.606 195.173 297.31 195.92C298.014 196.667 298.366 197.733 298.366 199.12C298.366 200.123 298.132 200.965 297.662 201.648C297.193 202.352 296.478 202.875 295.518 203.216C294.58 203.557 293.385 203.728 291.934 203.728ZM292.19 201.04C293.406 201.04 294.302 200.891 294.878 200.592C295.454 200.315 295.742 199.856 295.742 199.216C295.742 198.832 295.668 198.512 295.518 198.256C295.39 198 295.145 197.797 294.782 197.648C294.42 197.499 293.897 197.392 293.214 197.328L290.302 197.072C290.068 197.307 289.844 197.541 289.63 197.776C289.417 198.011 289.246 198.256 289.118 198.512C288.99 198.789 288.926 199.077 288.926 199.376C288.926 199.931 289.161 200.347 289.63 200.624C290.1 200.901 290.953 201.04 292.19 201.04ZM292.03 189.936C292.521 189.936 292.905 189.851 293.182 189.68C293.481 189.488 293.705 189.221 293.854 188.88C294.004 188.517 294.1 188.08 294.142 187.568C294.206 187.056 294.238 186.48 294.238 185.84C294.238 185.2 294.206 184.624 294.142 184.112C294.1 183.579 294.004 183.131 293.854 182.768C293.726 182.384 293.513 182.096 293.214 181.904C292.937 181.712 292.553 181.616 292.062 181.616C291.593 181.616 291.198 181.712 290.878 181.904C290.58 182.096 290.356 182.373 290.206 182.736C290.057 183.077 289.95 183.515 289.886 184.048C289.822 184.56 289.79 185.157 289.79 185.84C289.79 186.416 289.812 186.96 289.854 187.472C289.918 187.963 290.025 188.389 290.174 188.752C290.345 189.115 290.58 189.403 290.878 189.616C291.177 189.829 291.561 189.936 292.03 189.936ZM306.036 198.256C304.585 198.256 303.465 197.979 302.676 197.424C301.886 196.848 301.332 196.016 301.012 194.928C300.713 193.819 300.564 192.464 300.564 190.864V186.64C300.564 184.997 300.724 183.632 301.044 182.544C301.364 181.456 301.918 180.635 302.708 180.08C303.518 179.525 304.628 179.248 306.036 179.248C307.593 179.248 308.734 179.568 309.46 180.208C310.206 180.848 310.697 181.776 310.932 182.992C311.166 184.187 311.284 185.627 311.284 187.312V188.816H303.988V192.528C303.988 193.275 304.052 193.883 304.18 194.352C304.329 194.821 304.553 195.173 304.852 195.408C305.172 195.621 305.577 195.728 306.068 195.728C306.58 195.728 306.964 195.611 307.22 195.376C307.497 195.12 307.678 194.768 307.764 194.32C307.87 193.851 307.924 193.307 307.924 192.688V191.568H311.252V192.272C311.252 194.128 310.857 195.589 310.068 196.656C309.278 197.723 307.934 198.256 306.036 198.256ZM303.988 186.96H307.924V185.296C307.924 184.528 307.881 183.888 307.796 183.376C307.71 182.843 307.529 182.448 307.252 182.192C306.996 181.915 306.58 181.776 306.004 181.776C305.449 181.776 305.022 181.904 304.724 182.16C304.446 182.416 304.254 182.853 304.148 183.472C304.041 184.069 303.988 184.901 303.988 185.968V186.96ZM319.312 198.256C318.352 198.256 317.574 198.075 316.976 197.712C316.4 197.349 315.974 196.837 315.696 196.176C315.44 195.515 315.312 194.736 315.312 193.84V181.776H313.36V179.504H315.312V174.096H318.736V179.504H321.712V181.776H318.736V193.616C318.736 194.341 318.854 194.864 319.088 195.184C319.323 195.483 319.771 195.632 320.432 195.632C320.603 195.632 320.795 195.621 321.008 195.6C321.243 195.579 321.467 195.557 321.68 195.536V198.064C321.254 198.128 320.859 198.171 320.496 198.192C320.134 198.235 319.739 198.256 319.312 198.256ZM331.765 198V179.504H335.189V198H331.765ZM331.765 176.752V173.168H335.189V176.752H331.765ZM338.853 198V179.504H342.277V181.328C342.896 180.752 343.578 180.261 344.325 179.856C345.072 179.451 345.893 179.248 346.789 179.248C347.536 179.248 348.101 179.44 348.485 179.824C348.89 180.208 349.168 180.688 349.317 181.264C349.488 181.84 349.573 182.427 349.573 183.024V198H346.149V184.016C346.149 183.355 346.053 182.843 345.861 182.48C345.669 182.117 345.274 181.936 344.677 181.936C344.293 181.936 343.888 182.053 343.461 182.288C343.056 182.501 342.661 182.768 342.277 183.088V198H338.853ZM365.156 198.256C364.196 198.256 363.417 198.075 362.82 197.712C362.244 197.349 361.817 196.837 361.54 196.176C361.284 195.515 361.156 194.736 361.156 193.84V181.776H359.204V179.504H361.156V174.096H364.58V179.504H367.556V181.776H364.58V193.616C364.58 194.341 364.697 194.864 364.932 195.184C365.167 195.483 365.615 195.632 366.276 195.632C366.447 195.632 366.639 195.621 366.852 195.6C367.087 195.579 367.311 195.557 367.524 195.536V198.064C367.097 198.128 366.703 198.171 366.34 198.192C365.977 198.235 365.583 198.256 365.156 198.256ZM375.16 198.256C373.794 198.256 372.717 197.979 371.928 197.424C371.138 196.869 370.573 196.08 370.232 195.056C369.912 194.032 369.752 192.827 369.752 191.44V186.064C369.752 184.677 369.912 183.472 370.232 182.448C370.573 181.424 371.138 180.635 371.928 180.08C372.717 179.525 373.794 179.248 375.16 179.248C376.525 179.248 377.592 179.525 378.36 180.08C379.149 180.635 379.704 181.424 380.024 182.448C380.365 183.472 380.536 184.677 380.536 186.064V191.44C380.536 192.827 380.365 194.032 380.024 195.056C379.704 196.08 379.149 196.869 378.36 197.424C377.592 197.979 376.525 198.256 375.16 198.256ZM375.16 195.728C375.821 195.728 376.28 195.536 376.536 195.152C376.813 194.768 376.973 194.267 377.016 193.648C377.08 193.008 377.112 192.347 377.112 191.664V185.872C377.112 185.168 377.08 184.507 377.016 183.888C376.973 183.269 376.813 182.768 376.536 182.384C376.28 181.979 375.821 181.776 375.16 181.776C374.498 181.776 374.029 181.979 373.752 182.384C373.474 182.768 373.304 183.269 373.24 183.888C373.197 184.507 373.176 185.168 373.176 185.872V191.664C373.176 192.347 373.197 193.008 373.24 193.648C373.304 194.267 373.474 194.768 373.752 195.152C374.029 195.536 374.498 195.728 375.16 195.728ZM386.322 198.256C385.596 198.256 385.031 198.064 384.626 197.68C384.22 197.296 383.932 196.816 383.762 196.24C383.612 195.664 383.538 195.077 383.538 194.48V179.504H386.962V193.456C386.962 194.117 387.058 194.64 387.25 195.024C387.442 195.387 387.836 195.568 388.434 195.568C388.818 195.568 389.212 195.461 389.618 195.248C390.044 195.013 390.45 194.736 390.834 194.416V179.504H394.258V198H390.834V196.176C390.236 196.752 389.554 197.243 388.786 197.648C388.039 198.053 387.218 198.256 386.322 198.256ZM402.815 198.256C401.301 198.256 400.149 197.957 399.359 197.36C398.591 196.741 398.069 195.877 397.791 194.768C397.535 193.659 397.407 192.368 397.407 190.896V186.64C397.407 185.083 397.546 183.76 397.823 182.672C398.101 181.563 398.623 180.72 399.391 180.144C400.181 179.547 401.322 179.248 402.815 179.248C404.159 179.248 405.194 179.472 405.919 179.92C406.666 180.347 407.178 180.997 407.455 181.872C407.733 182.725 407.871 183.792 407.871 185.072V186.16H404.767V185.04C404.767 184.229 404.714 183.589 404.607 183.12C404.501 182.651 404.309 182.309 404.031 182.096C403.754 181.883 403.359 181.776 402.847 181.776C402.293 181.776 401.866 181.904 401.567 182.16C401.269 182.416 401.066 182.853 400.959 183.472C400.874 184.069 400.831 184.891 400.831 185.936V191.76C400.831 193.339 400.981 194.395 401.279 194.928C401.578 195.461 402.111 195.728 402.879 195.728C403.455 195.728 403.871 195.6 404.127 195.344C404.405 195.067 404.575 194.683 404.639 194.192C404.725 193.701 404.767 193.147 404.767 192.528V191.024H407.871V192.304C407.871 193.541 407.722 194.608 407.423 195.504C407.146 196.4 406.634 197.083 405.887 197.552C405.162 198.021 404.138 198.256 402.815 198.256ZM411.012 198V172.08H414.436V181.424C415.054 180.827 415.748 180.315 416.516 179.888C417.284 179.461 418.137 179.248 419.076 179.248C419.801 179.248 420.356 179.44 420.74 179.824C421.145 180.208 421.422 180.688 421.572 181.264C421.742 181.84 421.828 182.427 421.828 183.024V198H418.404V184.016C418.404 183.355 418.308 182.843 418.116 182.48C417.924 182.117 417.529 181.936 416.932 181.936C416.526 181.936 416.1 182.053 415.652 182.288C415.225 182.523 414.82 182.811 414.436 183.152V198H411.012ZM216.935 234L213.959 215.504H216.775L218.695 229.136L221.159 215.504H223.783L226.247 229.072L228.167 215.504H230.983L227.911 234H225.031L222.503 220.944L220.007 234H216.935ZM233.827 234V215.504H237.251V234H233.827ZM233.827 212.752V209.168H237.251V212.752H233.827ZM245.844 234.256C244.884 234.256 244.105 234.075 243.508 233.712C242.932 233.349 242.505 232.837 242.228 232.176C241.972 231.515 241.844 230.736 241.844 229.84V217.776H239.892V215.504H241.844V210.096H245.268V215.504H248.244V217.776H245.268V229.616C245.268 230.341 245.385 230.864 245.62 231.184C245.854 231.483 246.302 231.632 246.964 231.632C247.134 231.632 247.326 231.621 247.54 231.6C247.774 231.579 247.998 231.557 248.212 231.536V234.064C247.785 234.128 247.39 234.171 247.028 234.192C246.665 234.235 246.27 234.256 245.844 234.256ZM250.855 234V208.08H254.279V217.424C254.898 216.827 255.591 216.315 256.359 215.888C257.127 215.461 257.981 215.248 258.919 215.248C259.645 215.248 260.199 215.44 260.583 215.824C260.989 216.208 261.266 216.688 261.415 217.264C261.586 217.84 261.671 218.427 261.671 219.024V234H258.247V220.016C258.247 219.355 258.151 218.843 257.959 218.48C257.767 218.117 257.373 217.936 256.775 217.936C256.37 217.936 255.943 218.053 255.495 218.288C255.069 218.523 254.663 218.811 254.279 219.152V234H250.855ZM272.034 238.64V236.016C272.866 236.016 273.527 235.973 274.018 235.888C274.508 235.824 274.86 235.685 275.074 235.472C275.287 235.28 275.394 235.003 275.394 234.64C275.394 234.448 275.319 234.021 275.17 233.36C275.02 232.699 274.86 231.995 274.69 231.248L270.978 215.504H274.434L276.93 229.328L279.33 215.504H282.786L278.37 235.024C278.178 235.92 277.826 236.624 277.314 237.136C276.802 237.669 276.14 238.053 275.33 238.288C274.54 238.523 273.58 238.64 272.45 238.64H272.034ZM289.941 234.256C288.576 234.256 287.498 233.979 286.709 233.424C285.92 232.869 285.354 232.08 285.013 231.056C284.693 230.032 284.533 228.827 284.533 227.44V222.064C284.533 220.677 284.693 219.472 285.013 218.448C285.354 217.424 285.92 216.635 286.709 216.08C287.498 215.525 288.576 215.248 289.941 215.248C291.306 215.248 292.373 215.525 293.141 216.08C293.93 216.635 294.485 217.424 294.805 218.448C295.146 219.472 295.317 220.677 295.317 222.064V227.44C295.317 228.827 295.146 230.032 294.805 231.056C294.485 232.08 293.93 232.869 293.141 233.424C292.373 233.979 291.306 234.256 289.941 234.256ZM289.941 231.728C290.602 231.728 291.061 231.536 291.317 231.152C291.594 230.768 291.754 230.267 291.797 229.648C291.861 229.008 291.893 228.347 291.893 227.664V221.872C291.893 221.168 291.861 220.507 291.797 219.888C291.754 219.269 291.594 218.768 291.317 218.384C291.061 217.979 290.602 217.776 289.941 217.776C289.28 217.776 288.81 217.979 288.533 218.384C288.256 218.768 288.085 219.269 288.021 219.888C287.978 220.507 287.957 221.168 287.957 221.872V227.664C287.957 228.347 287.978 229.008 288.021 229.648C288.085 230.267 288.256 230.768 288.533 231.152C288.81 231.536 289.28 231.728 289.941 231.728ZM301.103 234.256C300.377 234.256 299.812 234.064 299.407 233.68C299.001 233.296 298.713 232.816 298.543 232.24C298.393 231.664 298.319 231.077 298.319 230.48V215.504H301.743V229.456C301.743 230.117 301.839 230.64 302.031 231.024C302.223 231.387 302.617 231.568 303.215 231.568C303.599 231.568 303.993 231.461 304.399 231.248C304.825 231.013 305.231 230.736 305.615 230.416V215.504H309.039V234H305.615V232.176C305.017 232.752 304.335 233.243 303.567 233.648C302.82 234.053 301.999 234.256 301.103 234.256ZM324.141 234.256C322.626 234.256 321.41 233.787 320.493 232.848C319.576 231.888 319.053 230.629 318.925 229.072L321.773 228.208C321.944 229.381 322.232 230.267 322.637 230.864C323.042 231.44 323.64 231.728 324.429 231.728C325.048 231.728 325.517 231.557 325.837 231.216C326.157 230.853 326.317 230.373 326.317 229.776C326.317 229.243 326.2 228.763 325.965 228.336C325.73 227.909 325.346 227.472 324.813 227.024L321.645 224.304C321.005 223.749 320.461 223.131 320.013 222.448C319.586 221.765 319.373 220.88 319.373 219.792C319.373 218.811 319.565 217.989 319.949 217.328C320.354 216.645 320.909 216.133 321.613 215.792C322.338 215.429 323.181 215.248 324.141 215.248C325.613 215.248 326.733 215.728 327.501 216.688C328.29 217.627 328.738 218.768 328.845 220.112L326.541 220.976C326.456 220.336 326.328 219.781 326.157 219.312C325.986 218.821 325.752 218.448 325.453 218.192C325.154 217.915 324.76 217.776 324.269 217.776C323.714 217.776 323.266 217.968 322.925 218.352C322.605 218.715 322.445 219.152 322.445 219.664C322.445 219.984 322.509 220.304 322.637 220.624C322.786 220.923 323.032 221.221 323.373 221.52L326.637 224.528C327.085 224.933 327.501 225.371 327.885 225.84C328.29 226.309 328.621 226.843 328.877 227.44C329.133 228.037 329.261 228.731 329.261 229.52C329.261 230.565 329.048 231.44 328.621 232.144C328.194 232.848 327.597 233.381 326.829 233.744C326.061 234.085 325.165 234.256 324.141 234.256ZM331.918 234V208.08H335.342V217.424C335.96 216.827 336.654 216.315 337.422 215.888C338.19 215.461 339.043 215.248 339.982 215.248C340.707 215.248 341.262 215.44 341.646 215.824C342.051 216.208 342.328 216.688 342.478 217.264C342.648 217.84 342.734 218.427 342.734 219.024V234H339.31V220.016C339.31 219.355 339.214 218.843 339.022 218.48C338.83 218.117 338.435 217.936 337.838 217.936C337.432 217.936 337.006 218.053 336.558 218.288C336.131 218.523 335.726 218.811 335.342 219.152V234H331.918ZM351.16 234.256C349.794 234.256 348.717 233.979 347.928 233.424C347.138 232.869 346.573 232.08 346.232 231.056C345.912 230.032 345.752 228.827 345.752 227.44V222.064C345.752 220.677 345.912 219.472 346.232 218.448C346.573 217.424 347.138 216.635 347.928 216.08C348.717 215.525 349.794 215.248 351.16 215.248C352.525 215.248 353.592 215.525 354.36 216.08C355.149 216.635 355.704 217.424 356.024 218.448C356.365 219.472 356.536 220.677 356.536 222.064V227.44C356.536 228.827 356.365 230.032 356.024 231.056C355.704 232.08 355.149 232.869 354.36 233.424C353.592 233.979 352.525 234.256 351.16 234.256ZM351.16 231.728C351.821 231.728 352.28 231.536 352.536 231.152C352.813 230.768 352.973 230.267 353.016 229.648C353.08 229.008 353.112 228.347 353.112 227.664V221.872C353.112 221.168 353.08 220.507 353.016 219.888C352.973 219.269 352.813 218.768 352.536 218.384C352.28 217.979 351.821 217.776 351.16 217.776C350.498 217.776 350.029 217.979 349.752 218.384C349.474 218.768 349.304 219.269 349.24 219.888C349.197 220.507 349.176 221.168 349.176 221.872V227.664C349.176 228.347 349.197 229.008 349.24 229.648C349.304 230.267 349.474 230.768 349.752 231.152C350.029 231.536 350.498 231.728 351.16 231.728ZM359.762 234V215.504H363.186V218.128C363.868 216.997 364.551 216.24 365.234 215.856C365.916 215.472 366.599 215.28 367.282 215.28C367.367 215.28 367.442 215.28 367.506 215.28C367.591 215.28 367.698 215.291 367.826 215.312V219.088C367.57 218.981 367.271 218.896 366.93 218.832C366.61 218.747 366.279 218.704 365.938 218.704C365.404 218.704 364.914 218.832 364.466 219.088C364.039 219.323 363.612 219.792 363.186 220.496V234H359.762ZM374.875 234.256C373.915 234.256 373.136 234.075 372.539 233.712C371.963 233.349 371.536 232.837 371.259 232.176C371.003 231.515 370.875 230.736 370.875 229.84V217.776H368.923V215.504H370.875V210.096H374.299V215.504H377.275V217.776H374.299V229.616C374.299 230.341 374.416 230.864 374.651 231.184C374.885 231.483 375.333 231.632 375.995 231.632C376.165 231.632 376.357 231.621 376.571 231.6C376.805 231.579 377.029 231.557 377.243 231.536V234.064C376.816 234.128 376.421 234.171 376.059 234.192C375.696 234.235 375.301 234.256 374.875 234.256ZM380.111 234V208.08H383.535V234H380.111ZM386.815 238.64V236.016C387.647 236.016 388.308 235.973 388.799 235.888C389.29 235.824 389.642 235.685 389.855 235.472C390.068 235.28 390.175 235.003 390.175 234.64C390.175 234.448 390.1 234.021 389.951 233.36C389.802 232.699 389.642 231.995 389.471 231.248L385.759 215.504H389.215L391.711 229.328L394.111 215.504H397.567L393.151 235.024C392.959 235.92 392.607 236.624 392.095 237.136C391.583 237.669 390.922 238.053 390.111 238.288C389.322 238.523 388.362 238.64 387.231 238.64H386.815ZM399.474 234V230.192H402.898V234H399.474Z"
                      fill="#F8F8F8"
                    />
                    <g opacity="0.02">
                      <path
                        opacity="0.0526316"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M480.648 370.66C491.627 322.47 499.972 259.365 547.72 246.715C594.674 234.275 622.267 297.067 663.871 322.118C704.544 346.609 766.012 343.241 782.192 387.9C800.489 438.406 778.454 496.832 741.19 535.534C704.307 573.842 648.853 589.968 596.516 580.747C549.061 572.386 515.206 533.829 491.927 491.619C471.358 454.324 471.184 412.205 480.648 370.66Z"
                        stroke="url(#paint1_linear_1_5300)"
                        stroke-width="1.05263"
                      />
                      <path
                        opacity="0.105263"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M477.715 367.75C490.515 320.09 501.259 257.447 549.387 246.657C596.712 236.046 621.838 299.753 662.39 326.344C702.034 352.339 763.495 351.335 777.927 396.514C794.249 447.607 770.024 505.056 731.36 542.243C693.091 579.05 637.143 593.013 585.275 581.806C538.246 571.645 505.944 531.876 484.333 488.869C465.239 450.869 466.679 408.838 477.715 367.75Z"
                        stroke="url(#paint2_linear_1_5300)"
                        stroke-width="1.10526"
                      />
                      <path
                        opacity="0.157895"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M474.673 365.061C489.272 317.999 502.392 255.91 550.826 246.989C598.453 238.217 621.082 302.744 660.524 330.829C699.084 358.286 760.446 359.641 773.116 405.272C787.444 456.875 761.071 513.266 721.069 548.886C681.474 584.142 625.116 595.928 573.793 582.758C527.258 570.816 496.551 529.899 476.637 486.16C459.041 447.514 462.088 405.633 474.673 365.061Z"
                        stroke="url(#paint3_linear_1_5300)"
                        stroke-width="1.15789"
                      />
                      <path
                        opacity="0.210526"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M471.516 362.586C487.885 316.191 503.355 254.745 552.022 247.702C599.879 240.776 619.986 306.025 658.264 335.559C695.686 364.432 756.86 368.137 767.753 414.15C780.072 466.187 751.597 521.438 710.319 555.444C669.462 589.103 612.778 598.701 562.074 583.592C516.1 569.893 487.03 527.891 468.835 483.487C452.759 444.254 457.404 402.584 471.516 362.586Z"
                        stroke="url(#paint4_linear_1_5300)"
                        stroke-width="1.21053"
                      />
                      <path
                        opacity="0.263158"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M468.235 360.325C486.345 314.662 504.134 253.949 552.963 248.787C600.978 243.712 618.54 309.585 655.602 340.52C691.834 370.763 752.729 376.805 761.835 423.132C772.133 475.523 741.605 529.558 699.116 561.904C657.061 593.92 600.135 601.322 550.124 584.303C504.777 568.872 477.381 525.85 460.928 480.849C446.391 441.088 452.622 399.691 468.235 360.325Z"
                        stroke="url(#paint5_linear_1_5300)"
                        stroke-width="1.26316"
                      />
                      <path
                        opacity="0.315789"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M464.824 358.267C484.642 313.402 504.718 253.508 553.635 250.231C601.738 247.008 616.737 313.406 652.53 345.692C687.523 377.256 748.05 385.62 755.361 432.191C763.629 484.859 731.099 537.601 687.466 568.244C644.278 598.575 587.196 603.777 537.948 584.879C493.295 567.744 467.608 523.769 452.916 478.239C439.934 438.01 447.738 396.946 464.824 358.267Z"
                        stroke="url(#paint6_linear_1_5300)"
                        stroke-width="1.31579"
                      />
                      <path
                        opacity="0.368421"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M461.271 356.41C482.764 312.407 505.09 253.418 554.023 252.024C602.141 250.654 614.563 317.476 649.039 351.062C682.744 383.897 742.816 394.563 748.326 441.309C754.557 494.175 720.08 545.55 675.371 574.45C631.118 603.056 573.964 606.058 525.551 585.314C481.653 566.505 457.709 521.644 444.794 475.654C433.383 435.018 442.742 394.346 461.271 356.41Z"
                        stroke="url(#paint7_linear_1_5300)"
                        stroke-width="1.36842"
                      />
                      <path
                        opacity="0.421053"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M457.573 354.747C480.704 311.667 505.239 253.668 554.116 254.154C602.179 254.632 612.012 321.78 645.125 356.612C677.497 390.665 737.025 403.611 740.732 450.462C744.924 503.447 708.556 553.384 662.84 580.504C617.59 607.348 560.45 608.151 512.94 585.598C469.861 565.148 447.689 519.47 436.565 473.088C426.736 432.108 437.632 391.886 457.573 354.747Z"
                        stroke="url(#paint8_linear_1_5300)"
                        stroke-width="1.42105"
                      />
                      <path
                        opacity="0.473684"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M453.722 353.272C478.451 311.177 505.152 254.25 553.901 256.61C601.837 258.93 609.077 326.302 640.78 362.325C671.775 397.543 730.673 412.742 732.577 459.63C734.73 512.656 696.531 561.084 649.879 586.39C603.702 611.438 546.659 610.048 500.12 585.723C457.922 563.668 437.549 517.243 428.227 470.54C419.99 429.275 432.403 389.562 453.722 353.272Z"
                        stroke="url(#paint9_linear_1_5300)"
                        stroke-width="1.47368"
                      />
                      <path
                        opacity="0.526316"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M449.709 351.979C475.995 310.928 504.817 255.154 553.365 259.378C601.105 263.531 605.747 331.028 636 368.186C665.575 404.512 723.759 421.936 723.862 468.791C723.979 521.779 684.011 568.633 636.494 592.092C589.462 615.312 532.601 611.738 487.098 585.684C445.84 562.059 427.292 514.959 419.779 468.004C413.142 426.516 427.048 387.37 449.709 351.979Z"
                        stroke="url(#paint10_linear_1_5300)"
                        stroke-width="1.52632"
                      />
                      <path
                        opacity="0.578947"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M445.529 350.86C473.328 310.91 504.222 256.368 552.499 262.444C599.972 268.419 602.018 335.941 630.779 374.175C658.896 411.553 716.281 431.169 714.589 477.921C712.676 530.794 671.003 576.009 622.695 597.593C574.88 618.957 518.284 613.21 473.882 585.469C433.621 560.316 416.919 512.611 411.222 465.474C406.189 423.826 421.563 385.302 445.529 350.86Z"
                        stroke="url(#paint11_linear_1_5300)"
                        stroke-width="1.57895"
                      />
                      <path
                        opacity="0.631579"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M441.177 349.911C470.443 311.117 503.357 257.884 551.292 265.798C598.429 273.58 597.884 341.028 625.115 380.278C651.737 418.649 708.241 440.422 704.762 487.004C700.828 539.683 657.517 583.197 608.491 602.879C559.965 622.361 503.717 614.456 460.478 585.076C421.272 558.436 406.435 510.198 402.557 462.949C399.131 421.203 415.946 383.355 441.177 349.911Z"
                        stroke="url(#paint12_linear_1_5300)"
                        stroke-width="1.63158"
                      />
                      <path
                        opacity="0.684211"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M436.644 349.123C467.33 311.539 502.209 259.689 549.732 269.423C596.464 278.995 593.337 346.27 619.003 386.475C644.094 425.781 699.636 449.671 694.381 496.013C688.438 548.423 643.558 590.177 593.889 607.935C544.727 625.511 488.91 615.467 446.894 584.495C408.797 556.411 395.841 507.714 393.782 460.424C391.962 418.64 410.189 381.523 436.644 349.123Z"
                        stroke="url(#paint13_linear_1_5300)"
                        stroke-width="1.68421"
                      />
                      <path
                        opacity="0.736842"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M431.926 348.488C463.983 312.167 500.768 261.772 547.81 273.307C594.07 284.649 588.373 351.651 612.44 392.75C635.97 432.929 690.471 458.895 683.452 504.931C675.515 556.993 629.137 596.932 578.901 612.744C529.177 628.395 473.871 616.233 433.136 583.72C396.202 554.239 385.141 505.155 384.898 457.893C384.683 416.135 404.29 379.801 431.926 348.488Z"
                        stroke="url(#paint14_linear_1_5300)"
                        stroke-width="1.73684"
                      />
                      <path
                        opacity="0.789474"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M427.017 348C460.392 312.991 499.024 264.121 545.518 277.433C591.238 290.525 582.987 357.156 605.426 399.084C627.363 440.075 680.745 468.072 671.979 513.734C662.066 565.374 614.264 603.444 563.536 617.293C513.325 631.002 458.61 616.746 419.214 582.744C383.493 551.914 374.337 502.517 375.905 455.353C377.29 413.681 398.244 378.182 427.017 348Z"
                        stroke="url(#paint15_linear_1_5300)"
                        stroke-width="1.78947"
                      />
                      <path
                        opacity="0.842105"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M421.911 347.652C456.551 314.002 496.967 266.724 542.845 281.79C587.96 296.605 577.175 362.768 597.957 405.462C618.274 447.201 670.462 477.182 659.967 522.405C648.098 573.547 598.947 609.697 547.804 621.57C497.182 633.321 443.138 617 405.134 581.564C370.675 549.434 363.432 499.798 366.803 452.801C369.781 411.276 392.048 376.661 421.911 347.652Z"
                        stroke="url(#paint16_linear_1_5300)"
                        stroke-width="1.84211"
                      />
                      <path
                        opacity="0.894737"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M416.605 347.433C452.455 315.188 494.59 269.567 539.786 286.358C584.23 302.87 570.936 368.47 590.035 411.864C608.706 454.287 659.627 486.202 647.424 530.919C633.623 581.491 583.199 615.673 531.717 625.558C480.761 635.341 427.465 616.984 390.905 580.171C357.756 546.792 352.431 496.991 357.594 450.23C362.156 408.914 385.698 375.231 416.605 347.433Z"
                        stroke="url(#paint17_linear_1_5300)"
                        stroke-width="1.89474"
                      />
                      <path
                        opacity="0.947368"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M411.093 347.338C448.097 316.541 491.883 272.641 536.333 291.127C580.043 309.305 564.266 374.246 581.659 418.275C598.663 461.317 648.245 495.113 634.357 539.261C618.65 589.188 567.032 621.359 515.289 629.247C464.075 637.054 411.604 616.694 376.538 578.563C344.742 543.988 341.337 494.096 348.28 447.639C354.414 406.592 379.193 373.889 411.093 347.338Z"
                        stroke="url(#paint18_linear_1_5300)"
                        stroke-width="1.94737"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M405.372 347.358C443.47 318.05 488.838 275.928 532.478 296.077C575.392 315.89 557.164 380.079 572.83 424.674C588.146 468.272 636.32 503.892 620.773 547.407C603.189 596.618 550.457 626.737 498.531 632.622C447.134 638.448 395.563 616.122 362.038 576.732C331.64 541.017 330.154 491.107 338.86 445.022C346.553 404.303 372.527 372.624 405.372 347.358Z"
                        stroke="url(#paint19_linear_1_5300)"
                        stroke-width="2"
                      />
                    </g>
                    <g opacity="0.05">
                      <path
                        opacity="0.0526316"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M21.8565 -95.998C69.7483 -108.212 129.711 -129.573 162.75 -92.853C195.24 -56.7443 151.95 -3.54528 148.636 44.9055C145.396 92.2721 176.434 145.435 144.073 180.206C107.475 219.529 45.4308 226.572 -6.00929 211.067C-56.9245 195.721 -96.5711 153.729 -112.241 102.949C-126.449 56.9055 -107.581 9.18933 -80.6386 -30.7824C-56.8336 -66.0996 -19.4314 -85.4686 21.8565 -95.998Z"
                        stroke="url(#paint20_linear_1_5300)"
                        stroke-width="1.05263"
                      />
                      <path
                        opacity="0.105263"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M23.1074 -99.9356C71.359 -110.286 132.005 -129.301 163.562 -91.3962C194.594 -54.122 149.363 -2.70061 144.2 45.5156C139.152 92.6529 168.082 146.888 134.462 180.341C96.4406 218.174 34.2663 222.823 -16.4632 205.38C-66.6752 188.116 -104.623 144.698 -118.311 93.4293C-130.722 46.9432 -110.069 0.0562402 -81.6552 -38.794C-56.5506 -73.1202 -18.4906 -91.0123 23.1074 -99.9356Z"
                        stroke="url(#paint21_linear_1_5300)"
                        stroke-width="1.10526"
                      />
                      <path
                        opacity="0.157895"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M24.1132 -103.869C72.6522 -112.347 133.89 -128.995 163.923 -89.9641C193.456 -51.5831 146.357 -2.00969 139.357 45.9016C132.514 92.7408 159.3 147.965 124.474 180.055C85.0888 216.346 22.8771 218.601 -27.0691 199.252C-76.5057 180.101 -112.703 135.325 -124.396 83.6456C-134.997 36.7869 -112.593 -9.20423 -82.7555 -46.879C-56.3921 -80.1667 -17.7326 -96.56 24.1132 -103.869Z"
                        stroke="url(#paint22_linear_1_5300)"
                        stroke-width="1.15789"
                      />
                      <path
                        opacity="0.210526"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M24.8748 -107.808C73.6287 -114.406 135.365 -128.67 163.834 -88.5744C191.83 -49.1466 142.937 -1.48886 134.117 46.0476C125.494 92.5204 150.104 148.648 114.126 179.332C73.4393 214.033 11.2822 213.898 -37.8092 192.678C-86.3998 171.675 -120.799 125.61 -130.484 73.5973C-139.266 26.4364 -115.15 -18.5937 -83.9359 -55.041C-56.3565 -87.2441 -17.1563 -102.119 24.8748 -107.808Z"
                        stroke="url(#paint23_linear_1_5300)"
                        stroke-width="1.21053"
                      />
                      <path
                        opacity="0.263158"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M25.3904 -111.759C74.2866 -116.474 136.43 -128.339 163.298 -87.242C189.718 -46.8288 139.11 -1.15111 128.488 45.9416C118.103 91.9805 140.505 148.927 103.434 178.163C61.5091 211.227 -0.501789 208.711 -48.6685 185.656C-96.3437 162.836 -128.9 115.556 -136.569 63.2875C-143.523 15.8948 -117.736 -28.1108 -85.1959 -63.2805C-56.4447 -94.3549 -16.7634 -107.694 25.3904 -111.759Z"
                        stroke="url(#paint24_linear_1_5300)"
                        stroke-width="1.26316"
                      />
                      <path
                        opacity="0.315789"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M25.6655 -115.733C74.6314 -118.563 137.088 -128.021 162.32 -85.9849C187.131 -44.6489 134.887 -1.01269 122.484 45.568C110.359 91.1064 130.527 148.785 92.4188 176.535C49.3221 207.919 -12.4515 203.031 -59.6251 178.181C-106.317 153.585 -136.987 105.162 -142.636 52.7159C-147.757 5.16215 -120.342 -37.7571 -86.5277 -71.6013C-56.6508 -101.504 -16.5483 -113.293 25.6655 -115.733Z"
                        stroke="url(#paint25_linear_1_5300)"
                        stroke-width="1.31579"
                      />
                      <path
                        opacity="0.368421"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M25.6973 -119.741C74.6603 -120.689 137.338 -127.731 160.9 -84.8218C184.071 -42.627 130.273 -1.09038 116.113 44.9112C102.269 89.8834 120.181 148.206 81.0956 174.434C36.8939 204.096 -24.5518 196.851 -70.6656 170.249C-116.309 143.918 -145.053 94.4272 -148.678 41.8817C-151.965 -5.76236 -122.967 -47.5352 -87.9325 -80.008C-56.9772 -108.699 -16.514 -118.925 25.6973 -119.741Z"
                        stroke="url(#paint26_linear_1_5300)"
                        stroke-width="1.36842"
                      />
                      <path
                        opacity="0.421053"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M25.4904 -123.791C74.3783 -122.86 137.183 -127.484 159.047 -83.7675C180.547 -40.7788 125.28 -1.39673 109.388 43.9595C93.8524 88.3008 109.488 147.18 69.4859 171.852C24.2477 199.753 -36.7804 190.169 -81.7695 161.859C-126.3 133.838 -153.081 83.3557 -154.684 30.7885C-156.137 -16.8753 -125.604 -57.4436 -89.4039 -88.5011C-57.4192 -115.942 -16.6562 -124.594 25.4904 -123.791Z"
                        stroke="url(#paint27_linear_1_5300)"
                        stroke-width="1.42105"
                      />
                      <path
                        opacity="0.473684"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M25.046 -127.891C73.7868 -125.089 136.626 -127.296 156.764 -82.839C176.567 -39.1224 119.916 -1.94631 102.322 42.6996C85.1218 86.3465 98.4641 145.693 57.6078 168.777C11.4031 194.882 -49.1186 182.981 -92.92 153.01C-136.274 123.345 -161.059 71.949 -160.643 19.4377C-160.266 -28.1753 -128.247 -67.4828 -90.9394 -97.0837C-57.9757 -123.238 -16.9738 -130.308 25.046 -127.891Z"
                        stroke="url(#paint28_linear_1_5300)"
                        stroke-width="1.47368"
                      />
                      <path
                        opacity="0.526316"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M24.3661 -132.052C72.8883 -127.388 135.669 -127.182 154.057 -82.0526C172.139 -37.6748 114.192 -2.75286 94.9261 41.1189C76.0917 84.0091 87.1285 143.734 45.4804 165.201C-1.61975 189.477 -61.5473 175.283 -104.1 143.701C-146.218 112.44 -168.976 60.2096 -166.548 7.83173C-164.347 -39.6603 -130.894 -77.6529 -92.5359 -105.758C-58.6447 -130.59 -17.4653 -136.073 24.3661 -132.052Z"
                        stroke="url(#paint29_linear_1_5300)"
                        stroke-width="1.52632"
                      />
                      <path
                        opacity="0.578947"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M23.455 -136.282C71.6877 -129.769 134.317 -127.158 150.933 -81.4251C167.272 -36.4538 108.118 -3.83059 87.2149 39.2047C66.7792 81.2771 75.501 141.292 33.1249 161.114C-14.7984 183.531 -74.045 167.073 -115.29 133.93C-156.113 101.126 -176.817 48.1398 -172.386 -4.02772C-168.369 -51.3291 -133.536 -87.9547 -94.1883 -114.527C-59.4224 -138.005 -18.1267 -141.898 23.455 -136.282Z"
                        stroke="url(#paint30_linear_1_5300)"
                        stroke-width="1.57895"
                      />
                      <path
                        opacity="0.631579"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M22.314 -140.588C70.1868 -132.241 132.573 -127.236 147.398 -80.9694C161.976 -35.4728 101.706 -5.18943 79.2002 36.9484C57.1981 78.1434 63.599 138.358 20.5597 156.512C-28.1137 177.042 -86.594 158.35 -126.474 123.702C-165.946 89.4064 -184.572 35.7462 -178.151 -16.1347C-172.329 -63.176 -136.172 -98.3848 -95.8948 -123.39C-60.3082 -145.483 -18.9575 -147.784 22.314 -140.588Z"
                        stroke="url(#paint31_linear_1_5300)"
                        stroke-width="1.63158"
                      />
                      <path
                        opacity="0.684211"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.9479 -144.982C68.3914 -134.819 130.443 -127.435 143.46 -80.7037C156.26 -34.7507 94.9671 -6.84468 70.8972 34.3362C47.3658 74.5956 51.4435 134.92 7.80648 151.384C-41.5429 170.003 -99.1729 149.113 -137.633 113.014C-175.701 77.2832 -192.226 23.0298 -183.831 -28.4886C-176.219 -75.2013 -138.794 -108.945 -97.6502 -132.351C-61.2977 -153.031 -19.9533 -153.743 20.9479 -144.982Z"
                        stroke="url(#paint32_linear_1_5300)"
                        stroke-width="1.68421"
                      />
                      <path
                        opacity="0.736842"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M19.3603 -149.469C66.3056 -137.512 127.932 -127.766 139.128 -80.6417C150.137 -34.3016 87.9137 -8.80677 62.3198 31.3593C37.2986 70.6266 39.0539 130.971 -5.1146 145.727C-55.0651 162.413 -111.762 139.362 -148.75 101.87C-185.361 64.7613 -199.768 9.99664 -189.417 -41.0842C-180.031 -87.4002 -141.398 -119.635 -99.451 -141.411C-62.3887 -160.652 -21.1115 -159.778 19.3603 -149.469Z"
                        stroke="url(#paint33_linear_1_5300)"
                        stroke-width="1.73684"
                      />
                      <path
                        opacity="0.789474"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M17.5552 -154.06C63.9346 -140.331 125.047 -128.247 134.409 -80.7991C143.616 -34.1415 80.5581 -11.0881 53.4827 28.0069C27.0131 66.2271 26.4505 126.503 -18.1828 139.533C-68.6588 154.268 -124.343 129.096 -159.808 90.2721C-194.912 51.8441 -207.186 -3.34919 -194.9 -53.9184C-183.76 -99.7705 -143.979 -130.452 -101.293 -150.572C-63.5781 -168.35 -22.4288 -165.897 17.5552 -154.06Z"
                        stroke="url(#paint34_linear_1_5300)"
                        stroke-width="1.78947"
                      />
                      <path
                        opacity="0.842105"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.536 -158.763C61.2828 -143.288 121.792 -128.889 129.314 -81.1902C136.71 -34.2851 72.9124 -13.6995 44.3998 24.27C16.5252 61.3899 13.6526 121.509 -31.3781 132.799C-82.3036 145.567 -136.895 118.318 -170.791 78.2231C-204.341 38.5368 -214.47 -17.0022 -200.273 -66.9867C-187.4 -112.309 -146.534 -141.397 -103.174 -159.836C-64.8636 -176.129 -23.9026 -172.104 15.536 -158.763Z"
                        stroke="url(#paint35_linear_1_5300)"
                        stroke-width="1.84211"
                      />
                      <path
                        opacity="0.894737"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.3101 -163.586C58.3587 -146.393 118.177 -129.708 123.852 -81.8288C129.434 -34.7463 64.9924 -16.6515 35.0891 20.1399C5.85491 56.1081 0.683515 115.981 -44.677 125.52C-95.9756 136.309 -149.397 107.03 -181.677 65.727C-213.629 24.8451 -221.606 -30.9566 -205.524 -80.2842C-190.943 -125.011 -149.055 -152.468 -105.087 -169.204C-66.2396 -183.992 -25.5266 -178.408 13.3101 -163.586Z"
                        stroke="url(#paint36_linear_1_5300)"
                        stroke-width="1.89474"
                      />
                      <path
                        opacity="0.947368"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.88 -168.533C55.1661 -149.653 114.207 -130.715 118.034 -82.7263C121.797 -35.5365 56.8093 -19.9513 25.5636 15.6113C-4.98289 50.3781 -12.4384 109.917 -58.0609 117.698C-109.656 126.496 -161.832 95.2376 -192.455 52.791C-222.765 10.7775 -228.584 -45.2035 -210.648 -93.8034C-194.384 -137.87 -151.539 -163.66 -107.031 -178.674C-67.7049 -191.94 -27.2994 -184.809 10.88 -168.533Z"
                        stroke="url(#paint37_linear_1_5300)"
                        stroke-width="1.94737"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.25294 -173.615C51.7135 -153.081 109.893 -131.924 111.871 -83.898C113.815 -36.671 48.3791 -23.6107 15.8413 10.6743C-15.9685 44.1921 -25.6902 103.311 -71.5065 109.326C-123.32 116.128 -174.178 82.9413 -203.103 39.4178C-231.733 -3.66165 -235.391 -59.7386 -215.633 -107.541C-197.717 -150.885 -153.981 -174.975 -108.998 -188.251C-69.2542 -199.98 -29.2147 -191.317 8.25294 -173.615Z"
                        stroke="url(#paint38_linear_1_5300)"
                        stroke-width="2"
                      />
                    </g>
                  </g>
                  <rect
                    x="5.5"
                    y="3.5"
                    width="605"
                    height="361"
                    rx="7.5"
                    stroke="#77BE0B"
                    stroke-opacity="0.37"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_1_5300"
                    x="0"
                    y="0"
                    width="620"
                    height="376"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="2" dy="4" />
                    <feGaussianBlur stdDeviation="3.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.0545885 0 0 0 0 0.0625 0 0 0 0 0.0544271 0 0 0 0.08 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_1_5300"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_1_5300"
                      result="shape"
                    />
                  </filter>
                  <filter
                    id="filter1_df_1_5300"
                    x="-40.6987"
                    y="-120.908"
                    width="700.379"
                    height="751.946"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_1_5300"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_1_5300"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="150"
                      result="effect2_foregroundBlur_1_5300"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_1_5300"
                    x1="251.882"
                    y1="204.641"
                    x2="409.913"
                    y2="247.86"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#E4E4E4" />
                    <stop offset="1" stop-color="#D2C8EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_1_5300"
                    x1="473.24"
                    y1="378.887"
                    x2="779.254"
                    y2="476.444"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_1_5300"
                    x1="470.007"
                    y1="375.674"
                    x2="771.603"
                    y2="484.745"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint3_linear_1_5300"
                    x1="466.68"
                    y1="372.672"
                    x2="763.426"
                    y2="493.061"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint4_linear_1_5300"
                    x1="463.248"
                    y1="369.873"
                    x2="754.721"
                    y2="501.37"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint5_linear_1_5300"
                    x1="459.706"
                    y1="367.278"
                    x2="745.49"
                    y2="509.654"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint6_linear_1_5300"
                    x1="456.048"
                    y1="364.878"
                    x2="735.738"
                    y2="517.891"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint7_linear_1_5300"
                    x1="452.262"
                    y1="362.67"
                    x2="725.464"
                    y2="526.063"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint8_linear_1_5300"
                    x1="448.344"
                    y1="360.647"
                    x2="714.674"
                    y2="534.147"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint9_linear_1_5300"
                    x1="444.288"
                    y1="358.804"
                    x2="703.372"
                    y2="542.126"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint10_linear_1_5300"
                    x1="440.084"
                    y1="357.137"
                    x2="691.563"
                    y2="549.98"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint11_linear_1_5300"
                    x1="435.728"
                    y1="355.637"
                    x2="679.253"
                    y2="557.688"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint12_linear_1_5300"
                    x1="431.215"
                    y1="354.301"
                    x2="666.449"
                    y2="565.234"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint13_linear_1_5300"
                    x1="426.537"
                    y1="353.121"
                    x2="653.159"
                    y2="572.597"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint14_linear_1_5300"
                    x1="421.689"
                    y1="352.09"
                    x2="639.39"
                    y2="579.76"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint15_linear_1_5300"
                    x1="416.665"
                    y1="351.201"
                    x2="625.15"
                    y2="586.704"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint16_linear_1_5300"
                    x1="411.46"
                    y1="350.448"
                    x2="610.45"
                    y2="593.413"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint17_linear_1_5300"
                    x1="406.07"
                    y1="349.822"
                    x2="595.299"
                    y2="599.867"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint18_linear_1_5300"
                    x1="400.492"
                    y1="349.318"
                    x2="579.71"
                    y2="606.053"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint19_linear_1_5300"
                    x1="394.718"
                    y1="348.927"
                    x2="563.692"
                    y2="611.952"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint20_linear_1_5300"
                    x1="11.1559"
                    y1="-98.838"
                    x2="63.9388"
                    y2="217.984"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint21_linear_1_5300"
                    x1="12.5398"
                    y1="-103.18"
                    x2="53.0616"
                    y2="214.963"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint22_linear_1_5300"
                    x1="13.6938"
                    y1="-107.511"
                    x2="41.931"
                    y2="211.479"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint23_linear_1_5300"
                    x1="14.6186"
                    y1="-111.841"
                    x2="30.5659"
                    y2="207.523"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint24_linear_1_5300"
                    x1="15.3121"
                    y1="-116.176"
                    x2="18.9825"
                    y2="203.088"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint25_linear_1_5300"
                    x1="15.7794"
                    y1="-120.527"
                    x2="7.20408"
                    y2="198.168"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint26_linear_1_5300"
                    x1="16.0174"
                    y1="-124.903"
                    x2="-4.75453"
                    y2="192.752"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint27_linear_1_5300"
                    x1="16.0304"
                    y1="-129.312"
                    x2="-16.8711"
                    y2="186.838"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint28_linear_1_5300"
                    x1="15.8192"
                    y1="-133.763"
                    x2="-29.127"
                    y2="180.421"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint29_linear_1_5300"
                    x1="15.3855"
                    y1="-138.264"
                    x2="-41.503"
                    y2="173.495"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint30_linear_1_5300"
                    x1="14.733"
                    y1="-142.825"
                    x2="-53.978"
                    y2="166.056"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint31_linear_1_5300"
                    x1="13.8628"
                    y1="-147.45"
                    x2="-66.5338"
                    y2="158.105"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint32_linear_1_5300"
                    x1="12.7791"
                    y1="-152.152"
                    x2="-79.1491"
                    y2="149.637"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint33_linear_1_5300"
                    x1="11.4851"
                    y1="-156.936"
                    x2="-91.8044"
                    y2="140.651"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint34_linear_1_5300"
                    x1="9.9843"
                    y1="-161.812"
                    x2="-104.48"
                    y2="131.148"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint35_linear_1_5300"
                    x1="8.27975"
                    y1="-166.788"
                    x2="-117.156"
                    y2="121.126"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint36_linear_1_5300"
                    x1="6.37813"
                    y1="-171.87"
                    x2="-129.811"
                    y2="110.588"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint37_linear_1_5300"
                    x1="4.28158"
                    y1="-177.064"
                    x2="-142.427"
                    y2="99.5377"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient
                    id="paint38_linear_1_5300"
                    x1="1.99685"
                    y1="-182.38"
                    x2="-154.983"
                    y2="87.975"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ECECEC" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                  </linearGradient>
                  <clipPath id="clip0_1_5300">
                    <rect
                      x="5"
                      y="3"
                      width="606"
                      height="362"
                      rx="8"
                      fill="white"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </Suspense>
  );
};
